export function maskPhoneNumber(phoneNumber: string): string {
    const digits = phoneNumber.replace(/\D/g, '');
    if (digits.length < 4) {
        return phoneNumber;
    }
    
    let digitIndex = 0;
    let result = '';
    
    for (let i = 0; i < phoneNumber.length; i++) {
        const char = phoneNumber[i];
        
        if (/\d/.test(char)) {
            const isLastFourDigit = digitIndex >= digits.length - 4;
            result += isLastFourDigit ? char : '*';
            digitIndex++;
        } else {
            result += char;
        }
    }
    
    return result;
}
